import React from 'react';

interface IFieldsetProps {
  label: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
}

const Fieldset: React.FC<IFieldsetProps> = ({ label, children, style, labelStyle }) => {
  return (
    <fieldset
      style={{
        border: '1px solid #080808',
        padding: '2px',
        borderRadius: '4px',
        minWidth: 0,
        ...style
      }}
    >
      <legend style={{ padding: '0 6px', fontWeight: 600, ...labelStyle }}>
        {label}
      </legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/FieldSetComponent.tsx